// Updated in place when the dataset is refreshed - keep these in sync.
export const PUBLISHED_AT = "2026-08-03T12:29:00-07:00";
export const MODIFIED_AT = "2026-10-17T11:31:26-07:00";

export function formatResearchDate(value: string) {
  return new Intl.DateTimeFormat("en-GB", { timeZone: "America/Phoenix", day: "numeric", month: "long", year: "numeric" }).format(new Date(value));
}
